import React, {createContext, useState} from 'react';
import BkashPaymentService from "../services/BkashPaymentService";

export const BkashTransactionContext = createContext("BkashTransactionContext");

const BkashTransactionContextProvider = ({children}) => {

    const [bkashTransactions, setBkashTransactions] = useState(null);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);

    async function getAllBkashTransactions({page, size, pharmacyName, transactionNumber, from, to}) {
        try {
            setLoading(true);
            setErrorMsg('');

            const res = await BkashPaymentService.getAllBkashTransactions(page, size, pharmacyName, transactionNumber, from, to);
            setBkashTransactions(res.data.content);
            setTotalElements(res.data.totalElements);
            setTotalPaidAmount(res?.headers?.total || 0);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Billing Records. Please check the console.");
            console.log("error", error);
            return false;
        }
    }

    async function getBkashTransactionById(transactionId) {
        try {
            setLoading(true);
            setErrorMsg('');

            const res = await BkashPaymentService.getBkashTransactionById(transactionId);
            setSelectedTransaction(res.data);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Bkash Transaction details. Please check the console.");
            console.log("error", error);
            return false;
        }
    }

    return (
        <BkashTransactionContext.Provider value={{
            bkashTransactions,
            selectedTransaction,
            loading,
            errorMsg,
            totalElements,
            totalPaidAmount,
            getAllBkashTransactions,
            getBkashTransactionById
        }}>
            {children}
        </BkashTransactionContext.Provider>
    );
};

export default BkashTransactionContextProvider;
